__turbopack_context__.v({
  "applyNowContainer": "DownloadCTASticky-module-scss-module__Z1mZGG__applyNowContainer",
  "downloadBrochureContainer": "DownloadCTASticky-module-scss-module__Z1mZGG__downloadBrochureContainer",
  "downloadCTAContainer": "DownloadCTASticky-module-scss-module__Z1mZGG__downloadCTAContainer",
  "webinarApplyNow": "DownloadCTASticky-module-scss-module__Z1mZGG__webinarApplyNow",
});
